import { useState, useEffect } from 'react';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged, sendPasswordResetEmail } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import MasterPanel from './MasterPanel';
import OrderForm from './OrderForm';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (u) {
        const userDoc = await getDoc(doc(db, 'users', u.uid));
        if (userDoc.exists()) {
          setUser(u);
          setRole(userDoc.data().role);
        }
      } else {
        setUser(null);
        setRole(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Email veya şifre yanlış!');
    }
  };

  const logout = () => signOut(auth);

  if (loading) return <div className="center">Yükleniyor...</div>;

  if (!user) {
    return (
      <div className="login-container">
        <div className="login-card">
          <img src="/logo2.png" alt="Logo" style={{ height: 80, objectFit: 'contain', display: 'block', margin: '0 auto 20px' }} />
          <h1>Modüler Sipariş Sistemi</h1>
          <form onSubmit={login}>
            <input className="input" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
            <input className="input" type="password" placeholder="Şifre" value={password} onChange={e => setPassword(e.target.value)} required />
            {error && <p className="error">{error}</p>}
            <button className="btn-primary" type="submit">Giriş Yap</button>
          </form>
          <div style={{ textAlign: 'center', marginTop: 12 }}>
            <span
              style={{ fontSize: 13, color: '#4361ee', cursor: 'pointer', textDecoration: 'underline' }}
              onClick={async () => {
                if (!email) { alert('Email adresinizi girin!'); return; }
                await sendPasswordResetEmail(auth, email);
                alert('Şifre sıfırlama emaili gönderildi!');
              }}
            >
              Şifremi Unuttum
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1>Modüler Sipariş Sistemi</h1>
        <button className="btn-logout" onClick={logout}>Çıkış</button>
      </header>
      <main>
        <div style={{ textAlign: 'center', padding: '24px 0 8px' }}>
          <img src="/logo2.png" alt="Logo" style={{ height: 80, objectFit: 'contain' }} />
        </div>
        {role === 'master' ? <MasterPanel /> : <OrderForm currentUser={user} />}
      </main>
    </div>
  );
}

export default App;